// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "545") return "js/vendors-c7d8ada169122f7c.js";
if (chunkId === "691") return "js/vendor-super-form-80ee157f61851263.js";
  // return url for filenames based on template
  return "js/" + {"94": "vendor-vega","960": "vendor-interrai-english",}[chunkId] + "-" + {"94": "200bff5849b2c427","960": "a8ea3306f896f5a0",}[chunkId] + ".chunk.js"
}